<template>
<v-row no-gutters justify="end" align="center">
  <v-btn
    v-if="canSave"
    :loading="loading"
    color="#009688"
    class="white--text" 
    elevation="2"
    @click="$emit('click')"
  >
    <v-icon v-if="leftArrow" left>mdi-content-save</v-icon>
    {{ text }}
    <v-icon v-if="rightArrow" right>mdi-content-save</v-icon>
  </v-btn>
</v-row>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    recordStatus: {
      type: String,
      default: '',
    },
    recordId: {
      type: [String, Number],
      default: '',
    },
    text: {
      type: String,
      default: 'Guardar',
    },
    leftArrow: {
      type: Boolean,
      default: true,
    },
    rightArrow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    //aplica para todos
    canSave() {
      return (
        !['D', 'V', 'R'].includes(this.recordStatus) ||
        (this.recordStatus === 'R' && !isNaN(this.recordId))
      )
    },
  },
}
</script>
